export default {
  type: "Feature",
  properties: {
    name: "Улаанбаатар",
    location: [47.89608927375508, 106.92581176757812],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [106.35589599609375, 48.25851283439989],
        [106.58523559570312, 48.228332127214934],
        [106.78573608398438, 48.19813361113582],
        [106.875, 48.17341248658084],
        [106.92855834960938, 48.17707562779614],
        [107.09884643554688, 48.22009793454488],
        [107.14691162109375, 48.152344345643336],
        [107.19772338867188, 48.115683488677305],
        [107.26089477539062, 48.045955739960114],
        [107.33367919921875, 47.98532601005293],
        [107.38449096679688, 47.964180715412276],
        [107.44766235351562, 47.95774347215711],
        [107.53829956054686, 47.934746769467786],
        [107.57400512695312, 47.91081934432408],
        [107.56576538085938, 47.854638476529935],
        [107.54379272460938, 47.77809779004784],
        [107.51220703125, 47.669086647137576],
        [107.50808715820312, 47.65058757118734],
        [107.4078369140625, 47.63763431783611],
        [107.31582641601562, 47.63670896254457],
        [107.2320556640625, 47.65151268066222],
        [107.12356567382812, 47.711609647845975],
        [107.03704833984375, 47.732858147066494],
        [106.93817138671874, 47.73747623919626],
        [106.66488647460936, 47.711609647845975],
        [106.60858154296875, 47.7263921299974],
        [106.54129028320312, 47.73747623919626],
        [106.50283813476562, 47.76979141653638],
        [106.4959716796875, 47.81499895328108],
        [106.49871826171875, 47.86293128876346],
        [106.468505859375, 47.931066347509784],
        [106.4300537109375, 47.96601978044179],
        [106.42181396484375, 48.098260411732674],
        [106.3922882080078, 48.16516946195868],
        [106.37580871582031, 48.211862417203214],
        [106.35589599609375, 48.25851283439989],
      ],
    ],
  },
};
